import { useMutation } from '@tanstack/react-query';

import { FileParameter, MetadataClient, ReportType } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);
export interface IFileMutationVariables {
  fileName: string | null | undefined;
  reportType: ReportType | undefined;
  size: number | null | undefined;
  formFile: FileParameter | null | undefined;
}

function useUploadUserGuide() {
  return useMutation({
    mutationFn: ({
      reportType,
      fileName,
      size,
      formFile,
    }: IFileMutationVariables) => {
      if (reportType && typeof reportType === 'string') {
        return metadataClient.uploadUserGuide(
          reportType as ReportType,
          fileName,
          undefined,
          size,
          formFile,
        );
      }
      return metadataClient.uploadSiteUserGuide(
        fileName,
        undefined,
        size,
        formFile,
      );
    },
  });
}

export default useUploadUserGuide;
